import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { Message, Icon, Button, List, Label } from 'semantic-ui-react';
import Tooltip from 'material-ui/Tooltip';
import TextField from 'material-ui/TextField';
import { ModalTemplate, Loading, Button as Btn } from 'components';

import * as common from 'libs/commonFunc';

import classNames from 'classnames/bind';
import styles from './ExamTemplateCopy.css';
const cx = classNames.bind(styles);

class ExamTemplateCopy extends PureComponent {
  constructor(props) {
    super(props);
  }

  handleOnChangeServiceNo = e => {
    const { recordServiceNo } = this.props;
    recordServiceNo(e.target.value);
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;

    const {
      isAuth,
      coping,
      errorMessage,
      templateInfo,
      copyTemplate,
      onInitErrorMessage,
      handleOnToggleCopyModal
    } = this.props;
    const { handleOnChangeServiceNo } = this;

    const { templateNo, serviceTemplateNo, templateName, serviceNo, regEpoch } = templateInfo;

    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={cx('modal-admin modal-examTemplate-copy', 'common-content')}
        closeIcon
        onToggleModal={handleOnToggleCopyModal}
        visible
        header={
          <div>
            {defineMessages(formatMessage({ id: 'ExamTemplateCopy_1', defaultMessage: '훈련 양식(템플릿) 복제' }))}
          </div>
        }
        buttons={
          <div className={cx('inline-block')}>
            <Btn buttonColor="#bbbbbb" onClick={handleOnToggleCopyModal}>
              {defineMessages(formatMessage({ id: 'ExamTemplateCopy_2', defaultMessage: '취 소' }))}
            </Btn>
            <Btn className={cx('brand-button')} loading={coping} disabled={coping} onClick={copyTemplate}>
              {defineMessages(formatMessage({ id: 'ExamTemplateCopy_11', defaultMessage: '복 제' }))}
            </Btn>
          </div>
        }>
        <Loading
          active={coping}
          size="small"
          content={defineMessages(formatMessage({ id: 'ExamTemplateCopy_4', defaultMessage: '복제중...' }))}
        />
        <div className={cx('message-header')}>
          {defineMessages(
            formatMessage({
              id: 'ExamTemplateCopy_5',
              defaultMessage: '템플릿을 복제하여 새로 생성합니다.'
            })
          )}
          <br />
          {defineMessages(
            formatMessage({
              id: 'ExamTemplateCopy_10',
              defaultMessage: '다음 템플릿을 복제합니까?'
            })
          )}
        </div>
        <Message className={cx('template-detail-box')}>
          <div className={cx('template-detail')}>
            <List bulleted className={cx('template-detail-list')}>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>No</div>
                {serviceTemplateNo
                  ? serviceTemplateNo
                  : templateNo +
                    ' ' +
                    defineMessages(formatMessage({ id: 'ExamTemplateCopy_6', defaultMessage: '(기본 제공)' }))}
              </List.Item>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(formatMessage({ id: 'ExamTemplateCopy_7', defaultMessage: '템플릿명' }))}
                </div>
                {templateName}
              </List.Item>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(formatMessage({ id: 'ExamTemplateCopy_8', defaultMessage: '등록일시' }))}
                </div>
                {common.timeFormatFromUTCEpoch(regEpoch)}
              </List.Item>
            </List>
            {isAuth === 2 && (
              <List className={cx('template-detail-list')}>
                <span className={cx('materialTextField-title')}>
                  {defineMessages(
                    formatMessage({
                      id: 'ExamTemplateCopy_9',
                      defaultMessage: '대상 서비스 번호 (미입력 시 비공개 기본 템플릿으로 복제)'
                    })
                  )}
                </span>
                <List.Item className={cx('template-detail-item', 'input-parent')}>
                  <TextField
                    className={cx('input-area')}
                    error={!!errorMessage}
                    fullWidth
                    onChange={handleOnChangeServiceNo}
                    onKeyUp={onInitErrorMessage}
                  />
                  {!!errorMessage && (
                    <Label className={cx('pointing-label')} basic pointing>
                      {defineMessages(formatMessage({ id: 'LicenseEdit_50', defaultMessage: '잘못된 서비스 번호입니다.' }))}
                    </Label>
                  )}
                </List.Item>
              </List>
            )}
          </div>
        </Message>
      </ModalTemplate>
    );
  }
}

export default injectIntl(ExamTemplateCopy);



// WEBPACK FOOTER //
// ./src/script/components/examTemplate/ExamTemplateCopy.js